export default __webpack_public_path__ + "static/media/jordi_figueras.ca0810c6.jpeg";